import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux'
import { getStore } from '../redux/store' 
import { notify } from '../redux/notifications/actions'
import Notifications from '../myjsx/components/notifications'


if (!otuApp.isCordovaApp() && !global.isPdf) {
	$( document ).ready(function() {

		messaging.initNotifications()

	})
}

global.messaging = {
	newMessageMemory:"",
	chatMessage:1,	
	highFiveMessage:2,
	shoutOutMessage:4,
	messageMessage:3,
	modalLoaded:false,
	modalOpen:false,
	modalActiveScreen:null,
	modalActiveScreenReloadUrl:null,
	unreadShoutOuts:0,
	unreadChats:0,
	unreadMessages:0,
	unreadHighFives:0,
	popupsQueued:[],
	popupsShown:[],
	dashboardReloadUrl:null,
	chatChannel:'new',
	chatChannelFk:'new',
	chatReloadUrl:null,
	chatsListReloadUrl:null,
	newChatReloadUrl:null,
	highFiveChannel:'new',
	highFiveChannelFk:'new',
	highFiveReloadUrl:null,
	highFivesListReloadUrl:null,
	newHighFiveReloadUrl:null,
	shoutOutChannel:'new',
	shoutOutChannelFk:'new',
	shoutOutReloadUrl:null,
	shoutOutsListReloadUrl:null,
	newShoutOutReloadUrl:null,
	messageChannel:'new',
	messageChannelFk:'new',
	messageReloadUrl:null,
	messagesListReloadUrl:null,
	newMessageReloadUrl:null,
	rebindMessageButtons:function() {
		$('.msg-send-highfive').off('click');
		$('.msg-send-highfive').click (function() {
				var userId=$(this).attr('data-user-id');
				if (typeof userId!='undefined')	messaging.sendHighFive(userId);
			});
		$('.msg-start-chat').off('click');
		$('.msg-start-chat').click (function() {
				var userId=$(this).attr('data-user-id');
				if (typeof userId!='undefined')	messaging.startChat(userId);
			});		
		$('.msg-view-profile').off('click');
		$('.msg-view-profile').click (function() {
				var userId=$(this).attr('data-user-id');
				if (typeof userId!='undefined')	messaging.viewProfile(userId);
			});	
		
	},
	handleShoutOutMessage:function(data) {
		this.updateMessageCounter();
		console.log('Messages - handling shoutOut message');

		const store = getStore();

		var doNotify = true;
		
		data.message.actionHandler = () => {
			console.log( data.message )
			messaging.activateShoutOutChannel({
				channel : data.message.channel,
				channelFk : data.message.channel_fk
			})
		} 


		if (messaging.modalLoaded) {
			console.log('Messages - Refresh Message modal');
			var url=null;
			if ( messaging.modalOpen && messaging.modalActiveScreen=='shoutOut' && messaging.shoutOutChannel==data.message.channel && messaging.shoutOutChannelFk==data.message.channel_fk) {
				/*
				 * Reload the current chat messages
				 */
				const refreshUnread = messaging.modalOpen;
				otuApp.appState.messagesUpdateUnread= refreshUnread;
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showShoutOutMessagesFrom&keepReply=1&channel=' + data.message.channel + '&channel_fk=' + data.message.channel_fk+ '&markRead=' + (+refreshUnread);

				if ( messaging.modalOpen) doNotify=false;
				
			} 

			if ( messaging.modalOpen && ( messaging.modalActiveScreen=='shoutOutsList' || messaging.modalActiveScreen=='dashBoard' ) ) {
				/*
				 * Just reload the new chat list preserving the top
				 */

				messaging.refreshModal();

				//url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showNewShoutOutMessagesList&channel='+ messaging.shoutOutChannel + '&channel_fk=' + messaging.shoutOutChannelFk;
			}
			
			if (url!=null) {
				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true}});		
			} else {
				this.unreadShoutOuts++;
				this.updateUnread(messaging.shoutOutMessage,this.unreadShoutOuts);
				//this.shoutOutReloadUrl=url;
			}
			
			$('#messageTab-t1 img').animateCSS('flash');
			
		}

		if ( doNotify ) 	store.dispatch( notify( data.message ));

	},	
	handleHighFiveMessage:function(data) {
		this.updateMessageCounter();
		console.log('Messages - handling highFive message');

		const store = getStore();

		var doNotify = true;

		data.message.actionHandler = () => {
			console.log( data.message )
			messaging.activateHighFiveChannel({
				channel : data.message.channel,
				channelFk : data.message.channel_fk
			})
		} 

		if (messaging.modalLoaded) {
			console.log('Messages - Refresh Message modal');
			
			var url=null;

			if ( messaging.modalOpen && messaging.modalActiveScreen=='highFive' && messaging.highFiveChannel==data.message.channel && messaging.highFiveChannelFk==data.message.channel_fk ) {

				/*
				 * Reload the current chat messages
				 */
				const refreshUnread = messaging.modalOpen;
				otuApp.appState.messagesUpdateUnread= refreshUnread;
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showHighFiveMessagesFrom&keepReply=1&channel=' + data.message.channel + '&channel_fk=' + data.message.channel_fk+ '&markRead=' + (+refreshUnread);

				if ( messaging.modalOpen) doNotify=false;

			} 


			if ( messaging.modalOpen && ( messaging.modalActiveScreen=='highFivesList' || messaging.modalActiveScreen=='dashBoard' )) {
				/*
				 * Just reload the new chat list preserving the top
				 */
				messaging.refreshModal();

				//url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showNewHighFiveMessagesList&channel='+ messaging.highFiveChannel + '&channel_fk=' + messaging.highFiveChannelFk;
			}

			
			if (url!==null) {
				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true}});		
			} else {
				this.unreadHighFives++;
				this.updateUnread(messaging.highFiveMessage,this.unreadHighFives);
				//this.highFiveReloadUrl=url;
			}
						
		}

		if ( doNotify ) 	store.dispatch( notify( data.message ));

	},
	/*
	 * handle ChatMessages
	 */
	handleChatMessage: function (data) {
		this.updateMessageCounter();
		console.log('Messages - handling chat message');

		const store = getStore();

		var doNotify = true;

		data.message.actionHandler = () => {
			console.log( data.message )
			messaging.activateChatChannel({
				channel : data.message.channel,
				channelFk : data.message.channel_fk
			})
		} 

		if (messaging.modalLoaded) {
			console.log('Messages - Refresh Message modal');


			var url=null;
			
			if ( messaging.modalOpen && messaging.modalActiveScreen=='chat' && messaging.chatChannel==data.message.channel && messaging.chatChannelFk==data.message.channel_fk) {
				
				/*
				 * Reload the current chat messages
				 */

					const refreshUnread = messaging.modalOpen;
					otuApp.appState.messagesUpdateUnread= refreshUnread;
					url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showChatMessagesFrom&keepReply=1&channel=' + data.message.channel + '&channel_fk=' + data.message.channel_fk + '&markRead=' + (+refreshUnread);

				if ( messaging.modalOpen) doNotify=false;

			} 


			if ( messaging.modalOpen && ( messaging.modalActiveScreen=='chatsList' || messaging.modalActiveScreen=='dashBoard' )) {
				/*
				 * Just reload the new chat list preserving the top
				 */

				 messaging.refreshModal();

				//url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showNewChatMessagesList&channel='+ messaging.chatChannel + '&channel_fk=' + messaging.chatChannelFk;
			}	
			

			if (url!==null ) {
				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true}});	
			} else {
				this.unreadChats++;
				this.updateUnread(messaging.chatMessage,this.unreadChats);
				//this.chatReloadUrl=url;
			}
						
		} 

		if ( doNotify ) 	store.dispatch( notify( data.message ));
		
		},
	/*
	 * handle Messages
	 */
	handleMessageMessage: function (data) {
		this.updateMessageCounter();
		console.log('Messages - handling message message');

		const store = getStore();

		var doNotify = true;

		data.message.actionHandler = () => {
			console.log( data.message )
			messaging.activateMessageChannel({
				channel : data.message.channel,
				channelFk : data.message.channel_fk
			})
		} 
		
		if (messaging.modalLoaded) {
			console.log('Messages - Refresh Message modal');


			var url=null;
			
			if (messaging.modalOpen &&  messaging.modalActiveScreen=='message' && messaging.messageChannel==data.message.channel && messaging.messageChannelFk==data.message.channel_fk) {
				/*
				 * Reload the current chat messages
				 */
				const refreshUnread = messaging.modalOpen;
				otuApp.appState.messagesUpdateUnread= refreshUnread;
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showMessageMessagesFrom&keepReply=1&channel=' + data.message.channel + '&channel_fk=' + data.message.channel_fk+ '&markRead=' + (+refreshUnread);

				if ( messaging.modalOpen) doNotify=false;

			} 
			if ( messaging.modalOpen && (messaging.modalActiveScreen=='messagesList' || messaging.modalActiveScreen=='dashBoard' ) ) {
				/*
				 * Just reload the new chat list preserving the top
				 */

				messaging.refreshModal();

				//url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showNewMessageMessagesList&channel='+ messaging.messageChannel + '&channel_fk=' + messaging.messageChannelFk;


			}


			if (url!==null) {
				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true}});		
			} else {
				this.unreadMessages++;
				this.updateUnread(messaging.messageMessage,this.unreadMessages);
				this.messageReloadUrl=url;
			}			
			
			$('#messageTab-t2 img').animateCSS('flash');

			if ( doNotify ) 	store.dispatch( notify( data.message ));

		} 
	},
	/*
	 * Sends a high five to this user
	 */
	sendHighFive: function(userId) {
		var target=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.send';
		var users=JSON.stringify({users:[parseInt(userId,10)]});	
		var data={ 'd': {'sendTo' : users, messageChannel:7,messageType:2}};
		var url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296';
		if (messaging.modalOpen) {
			otuApp.triggerAjaxPost(target,data,{attr:{'data-keep-animation':true},callback:function () {
			}});
		} else {
			otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
				otuApp.triggerAjaxPost(target,data,{attr:{'data-keep-animation':true},callback:function () {
				}});
			}});
		}
	},
		/*
	 * Sends a high five to this team
	 */
	sendTeamHighFive: function(teamId) {
		var target=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.send';
		var team=JSON.stringify({users:[teamId]});	
		var data={ 'd': {'sendTo' : team, messageChannel:15,messageType:2}};
		var url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296';
		if (messaging.modalOpen) {
			otuApp.triggerAjaxPost(target,data,{attr:{'data-keep-animation':true},callback:function () {
			}});
		} else {
			otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
				otuApp.triggerAjaxPost(target,data,{attr:{'data-keep-animation':true},callback:function () {
				}});
			}});
		}
	},
	/*
	 * Starts a shoutout with this user
	 */
	startShoutOut: function(userId) {
		var channelFk=null;
		if (parseInt(userId,10)>parseInt(otuApp.appUser.id,10)) 
			channelFk=otuApp.appUser.id + ',' + userId;
		else
			channelFk=userId + ',' + otuApp.appUser.id;
		
		var url=null;
		
		if (messaging.modalOpen) {
		
			url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showNewShoutOut&to=' + userId;
			otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {

			}});
		} else {
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296'
				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
					$('[data-template-position="tmpl-msg-dashboard"]').hide();
					url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showNewShoutOut&to=' + userId;
					otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
						$('[data-template-position="tmpl-msg-dashboard"]').fadeIn();
					}});
				}});
				
		}

	},
	/*
	 * Starts a shoutout with this team
	 */
	startTeamShoutOut: function(teamId) {
		var channelFk=teamId;
		var url=null;
		
		if (messaging.modalOpen) {
		
			url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showNewShoutOut';
			otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
				$('[data-channel-id="15"][data-id="'+ channelFk + '"]').trigger('click');
			}});
		} else {
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296'
				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
					$('[data-template-position="tmpl-msg-dashboard"]').hide();
					url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showNewShoutOut';
					otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
						$('[data-template-position="tmpl-msg-dashboard"]').fadeIn();
						$('[data-channel-id="15"][data-id="'+ channelFk + '"]').trigger('click');
					}});
				}});
				
		}

	},
	activateChatChannel: function(options) {
		const channel = options.channel
		const channelFk = options.channelFk

		var url=null;
		
		if (messaging.modalOpen) {

			url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showChatMessagesFrom&channel=' + channel + '&channel_fk='+ channelFk;

				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
					if (messaging.modalOpen) {
					
							$('#messageTab-t3').trigger('click');	

					}

				}});

				otuApp.fxQ.dequeue();

		} else {

				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296'
				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {

						$('[data-template-position="tmpl-msg-dashboard"]').hide();
						url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showChatMessagesFrom&channel=' + channel + '&channel_fk='+ channelFk;
						otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
							$('[data-template-position="tmpl-msg-dashboard"]').fadeIn();
						}});


				}});

			otuApp.fxQ.dequeue();

		}


	},
	activateHighFiveChannel: function(options) {
		const channel = options.channel
		const channelFk = options.channelFk

		
		var url=null;
		
		if (messaging.modalOpen) {
		
			url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showHighFiveMessagesFrom&channel=' + channel + '&channel_fk='+ channelFk;
			otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
				if (messaging.modalOpen) {
				
					$('#messageTab-t4').trigger('click');	
				
				}

				otuApp.fxQ.dequeue();

			}});
		} else {

				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296';
				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {


					$('[data-template-position="tmpl-msg-dashboard"]').hide();

						url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showHighFiveMessagesFrom&channel=' + channel + '&channel_fk='+ channelFk;
						otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
							$('[data-template-position="tmpl-msg-dashboard"]').fadeIn();
						}});

					}});		

				otuApp.fxQ.dequeue();
		}

	},
	activateMessageChannel: function(options) {
		const channel = options.channel
		const channelFk = options.channelFk

		
		var url=null;
		
		if (messaging.modalOpen) {
		
			url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showMessageMessagesFrom&channel=' + channel + '&channel_fk='+ channelFk;
			otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
				if (messaging.modalOpen) {
					$('#messageTab-t4').trigger('click');	
				}
			}});

			otuApp.fxQ.dequeue();

		} else {
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296'

				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {

					$('[data-template-position="tmpl-msg-dashboard"]').hide();
					
					url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showMessageMessagesFrom&channel=' + channel + '&channel_fk='+ channelFk;
					
					otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
						$('[data-template-position="tmpl-msg-dashboard"]').fadeIn();
					
					}});
				
				}});

				otuApp.fxQ.dequeue();
				
		}

	},
	activateShoutOutChannel: function(options) {
		const channel = options.channel
		const channelFk = options.channelFk

		
		var url=null;
		
		if (messaging.modalOpen) {
		
			url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showShoutOutMessagesFrom&channel=' + channel + '&channel_fk='+ channelFk;
			otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
				if (messaging.modalOpen) {
					$('#messageTab-t4').trigger('click');	
				}
			}});

			otuApp.fxQ.dequeue();

		} else {
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296';

				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {

					$('[data-template-position="tmpl-msg-dashboard"]').hide();

					url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showShoutOutMessagesFrom&channel=' + channel + '&channel_fk='+ channelFk;
					
					otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
						$('[data-template-position="tmpl-msg-dashboard"]').fadeIn();
					}});
				
				}});

				otuApp.fxQ.dequeue();

				
		}

	},
		/*
	 * Sends a high five to this user
	 */
	sendHighFive: function(userId) {
		var target=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.send';
		var users=JSON.stringify({users:[parseInt(userId,10)]});	
		var data={ 'd': {'sendTo' : users, messageChannel:7,messageType:2}};
		var url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296';
		if (messaging.modalOpen) {
			otuApp.triggerAjaxPost(target,data,{attr:{'data-keep-animation':true},callback:function () {
			}});
		} else {
			otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
				otuApp.triggerAjaxPost(target,data,{attr:{'data-keep-animation':true},callback:function () {
				}});
			}});
		}
	},
	/*
	 * Starts a chat with this user
	 */
	startChat: function(userId) {
		var channelFk=null;
		if (parseInt(userId,10)>parseInt(otuApp.appUser.id,10)) 
			channelFk=otuApp.appUser.id + ',' + userId;
		else
			channelFk=userId + ',' + otuApp.appUser.id;
		
		var url=null;
		
		if (messaging.modalOpen) {
		
			url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showChatMessagesFrom&channel=7&channel_fk='+ channelFk;
			otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
				if (messaging.modalOpen) {
					$('#messageTab-t3').trigger('click');	
				}
			}});
		} else {
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296'
				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
					$('[data-template-position="tmpl-msg-dashboard"]').hide();
					url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showChatMessagesFrom&channel=7&channel_fk='+ channelFk;
					otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
						$('[data-template-position="tmpl-msg-dashboard"]').fadeIn();
					}});
				}});
				
		}

	},
	/*
	 * Send Message to my students
	 */
	sendMessageToGroup: function(channelId=4) {
		var url=null;
		if (messaging.modalOpen) {
		
			url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showNewMessage';
			otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
				if (messaging.modalOpen) {
					$('.msgTabChooseUser [href="#message-choose-group-3"]').trigger('click');
					$('.group[data-channel-id="' + channelId + '"]').trigger('click');

				}
			}});
		} else {
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296'
				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
					$('[data-template-position="tmpl-msg-dashboard"]').hide();
					url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showNewMessage';
					otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
						$('.msgTabChooseUser [href="#message-choose-group-3"]').trigger('click');
						$('.group[data-channel-id="' + channelId + '"]').trigger('click');
						$('[data-template-position="tmpl-msg-dashboard"]').fadeIn();
					}});
				}});
				
		}

	},
		/*
	 * Starts a chat with this user
	 */
	startTeamChat: function(teamId) {
		var channelFk=teamId;
		var url=null;
		if (messaging.modalOpen) {
		
			url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showChatMessagesFrom&channel=15&channel_fk='+ channelFk;
			otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
				if (messaging.modalOpen) {
					$('#messageTab-t3').trigger('click');	
				}
			}});
		} else {
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296'
				otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
					$('[data-template-position="tmpl-msg-dashboard"]').hide();
					url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.showChatMessagesFrom&channel=15&channel_fk='+ channelFk;
					otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':true},callback:function () {
						$('[data-template-position="tmpl-msg-dashboard"]').fadeIn();
					}});
				}});
				
		}

	},
	/*
	 * Opens a users profile
	 */
	viewProfile : function (userId){
		var url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=goToProfile&profileId=' + userId + '&jsBack=1';
		console.log('Messages - viewProfile');
		console.log(url);
		otuApp.triggerAjaxGet(url,{attr:{'data-keep-animation':false},callback:function () {
			//close the modal messaging window if it is open
			console.log('Messages - messaging.modalOpen');
			if (messaging.modalOpen) {
				console.log('Messages - close modal');
				reloadIsland=false;	// a hack to to make this work when on a login redirect link 
				$('#modalMessages').modal('hide');
			}
		}})
	},
	updateMessageCounter: function (data) {
		var count=parseInt($.trim($('#newMessageCounter').text()),10);
		count++;
		$('#newMessageCounter').text(' ' + count);
		otuApp.preload({sounds:['new-message']}, function() {
			$('#newMessageCounter').animateCSS('flash');
			if (!messaging.modalOpen) {
				createjs.Sound.play('new-message',{volume:otuApp.fxOptions.newMessageVolume});
			}
		});

	},
	setMessageCounter: function (data) {
		var count=parseInt($.trim($('#newMessageCounter').text()),10);
		$('#newMessageCounter').text(' ' + data);
	},
	setMessageCounters:function(total,byType) {
		var type=null;
		var unread=0;		
		messaging.setMessageCounter(total);

		if (byType.hasOwnProperty(messaging.chatMessage)) {
			this.unreadChats=byType[messaging.chatMessage].count;
		} else this.unreadChats=0;
		
		if (byType.hasOwnProperty(messaging.highFiveMessage)) {
			this.unreadHighFives=byType[messaging.highFiveMessage].count;
		} else this.unreadHighFives=0;
		
		if (byType.hasOwnProperty(messaging.shoutOutMessage)) {
			this.unreadShoutOuts=byType[messaging.shoutOutMessage].count;
		} else this.unreadShoutOuts=0;
		
		if (byType.hasOwnProperty(messaging.messageMessage)) {
			this.unreadMessages=byType[messaging.messageMessage].count;
		} else this.unreadMessages=0;		

		$('.unread-counter-' + messaging.chatMessage).text(this.unreadChats);	
		$('.unread-counter-' + messaging.highFiveMessage).text(this.unreadHighFives);
		$('.unread-counter-' + messaging.shoutOutMessage).text(this.unreadShoutOuts);	
		$('.unread-counter-' + messaging.messageMessage).text(this.unreadMessages);		



 
	},
	updateUnread: function (type, unread) {
		switch (type) {
			case messaging.chatMessage:
				this.unreadChats=unread;
				$('.unread-counter-' + type ).text(unread);

				break;
			case messaging.highFiveMessage:
				this.unreadHighFives=unread;
				$('.unread-counter-' + type ).text(unread);
	
				break;
			case messaging.shoutOutMessage:
				this.unreadShoutOuts=unread;
				$('.unread-counter-' + type ).text(unread);
	
				break;
			case messaging.messageMessage:
				this.unreadMessages=unread;
				$('.unread-counter-' + type ).text(unread);
				break;

		}
		this.setMessageCounter(this.unreadChats+this.unreadHighFives+this.unreadShoutOuts+this.unreadMessages);
	},
	openModal:function (type) {
		if (messaging.modalOpen) return true;
		
		if (!messaging.modalLoaded) { 
		
			var url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=296';
			otuApp.triggerAjaxGet(url,{attr:{"data-keep-animation":true}, callback:function () {
				
				
				if (messaging.modalLoaded) {
				
					console.log('Messages - Messaging Modal loaded...');
					
					if (typeof type!='undefined' && type!=messaging.modalActiveScreen) {
						$('[data-template-position="tmpl-msg-dashboard"]').hide();
						messaging.modalActiveScreen=type;	
						messaging.refreshModal(function() {
							$('[data-template-position="tmpl-msg-dashboard"]').fadeIn();
						});						
		
					}
				} else {
					// messaging modal did not load so we got something else back
					//otuApp.appState.hiddenTemplatePositions.push('columns-all');

					console.log('Messages - Messaging Modal NOT loaded..., stopping animation beware...');
					// we assume it is not a map and stop the animations, if the returned screen is a map or a popup this may fail
					//otuApp.stopAnimations();

				}
					
				}
			});
		} else {
			if (typeof type!='undefined') {
				messaging.modalActiveScreen=type;	
			}
			
			messaging.refreshModal(function() {
				$('#modalMessages').modal('show');
			});		

		}
				
	},
	closeModal:function () {
		$('#modalMessages').modal('hide');

	},
	refreshModal:function (callback) {
		var url=null;

		switch (messaging.modalActiveScreen) {
			case 'dashBoard':
				url=messaging.dashboardReloadUrl;
				break;		
			case 'chat':
				url=messaging.chatReloadUrl;
				break;
			case 'newChat':
				url=messaging.newChatReloadUrl;
				break;				
			case 'chatsList':
				url=messaging.chatsListReloadUrl;
				break;	
			case 'shoutOut':
				url=messaging.shoutOutReloadUrl;
				break;
			case 'newShoutOut':
				url=messaging.newShoutOutReloadUrl;
				break;					
			case 'shoutOutsList':
				url=messaging.shoutOutsListReloadUrl;
				break;	
			case 'highFive':
				url=messaging.highFiveReloadUrl;
				break;
			case 'newhighFive':
				url=messaging.newHighFiveReloadUrl;
				break;				
			case 'highFivesList':
				url=messaging.highFivesListReloadUrl;
				break;	
			case 'message':
				url=messaging.messageReloadUrl;
				break;
			case 'newMessage':
				url=messaging.newMessageReloadUrl;
				break;				
			case 'messagesList':
				url=messaging.messagesListReloadUrl;
				break;					
		}
				
		if (url!==null) {
			otuApp.triggerAjaxGet(url,{attr:{"data-keep-animation":true},callback:function () {	
				console.log('Messages - Messaging Modal refreshed...');
				if (typeof callback === "function") {
					callback();
					}	
				}			
			});
		} else {
			if (typeof callback === "function") {

				callback();
				}	
		}
	},
	showPopup : function(popup) {
		otuApp.fxQ.queue(function(next) {
			console.log('Messages - Dequeuing popup (' + (popup.id) + ') '  + popup.url);
	    	otuApp.triggerAjaxGet(popup.url,{
	    		attr:{'data-keep-animation': 'true'},
	    		callback:function(){
	    			console.log('Messages - Popup (' + popup.id + ') in otuApp.fxQ to show');
	    			next();
	    		}
	    	});					
		})

	},
	showPopups : function (popups) {
		var popupsEnabled=true;
		var arrayLength = popups.length;
		var url=null;
		if (arrayLength===0) return false;
		
		if (typeof otuApp.appState.templateParams!='undefined') {
			if (otuApp.appState.templateParams.popupsEnabled===false)  { 
				popupsEnabled=false;
				console.log('Messages - Popups disabled');
			}
		}
		
		if (popupsEnabled) {
			console.log('Messages - Popups asked to queue (' + arrayLength + ')');
			for (var i = 0; i < arrayLength; i++) {
			    let popup=popups[i];
			    // check if we already queued the popup or shown it 
			    otuApp.popupQueued=-1;
			    for (let k=0;k< messaging.popupsQueued.length;k++) {
			    	if (messaging.popupsQueued[k].id==popup.id) {
			    		otuApp.popupQueued=k;
			    		break;
			    	}
			    }

			    
			    let popupShown=$.inArray(popup.id, messaging.popupsShown);
			    
			    if (otuApp.popupQueued===-1 && (popupShown===-1 || popup.repeat)) {
					console.log('Messages - Queuing popup message (' + popup.id + ')');
					console.log(popup.url);
					messaging.popupsQueued.push(popup);
				    otuApp.popupQ.queue(function (next){
				    	if (messaging.popupsQueued.length) {
					    	var nextPopup=messaging.popupsQueued.shift();
					    	console.log('Messages - Dequeueing popup (' + nextPopup.id + ')');
					    	if (typeof nextPopup.id!=='undefined') messaging.popupsShown.push(nextPopup.id); // we keep track of the popups shown to not get into a muddle if the same ones are added to the queue again
					    	messaging.showPopup(nextPopup);
				    	} else {
				    		console.log('Messages - Error - Popup queue asked to dequeue but queue is empty');
				    	}
				    });	
			    } else {
			    	if (popupShown!==-1) {
			    		console.log('Messages - Popup (' + popup.id + ') already shown');
			    	} else {
			    		console.log('Messages - Popup (' + popup.id + ') already queued');			    		
			    	}
			    }
			    
			} // loop
			console.log('Messages - Popups queued (' + popups.length + ')');
			

			
		} 
	},
	showWhoIsWho : function () {
		const url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=team.whoIsOnKnowledgeIsland';
		otuApp.triggerAjaxGet( url, {"attr":{"data-hide-template-position":"columns-all"}});
	},
	inviteFriend:function(Options={}) {
		var options = {
			data : {
				email : null,
				licenseKey : null,
				resend : null
			},
			url : null,
			callback: null

		};
		var options = $.extend(options,Options);

		if (typeof options.url===null) throw new Error('url is required');
		if (typeof options.data===null) throw new Error('data is required');
		if (typeof options.data.email===null) throw new Error('data,email is required');

		const url=options.url;

		otuApp.triggerAjaxPost( url, options.data, {
				responseType:'json',
				callback:function ( result ) {
					if (result.success) { console.log('User Invited to join by Email');	}
					else { ('User invite to join by email failed') }
					if (typeof options.callback === 'function') options.callback( result )

			}
		});
	},
	initNotifications : function() {
		const appStore = getStore();

		const element = (
			<Provider store = { appStore }>
				<Notifications></Notifications>
			</Provider>
		)
	
		ReactDOM.render( element, document.getElementById('notifications'), function (e) {})
	},
	clear:function() {
		messaging.modalLoaded=false;
		messaging.modalOpen=false;
		messaging.modalActiveScreen=null;
		messaging.modalActiveScreenReloadUrl=null;
		messaging.unreadShoutOuts=0;
		messaging.unreadChats=0;
		messaging.unreadMessages=0;
		messaging.unreadHighFives=0;
		messaging.popupsQueued=[];
		messaging.popupsShown=[];
		messaging.dashboardReloadUrl=null;
		messaging.chatChannel='new';
		messaging.chatChannelFk='new';
		messaging.chatReloadUrl=null;
		messaging.chatsListReloadUrl=null;
		messaging.newChatReloadUrl=null;
		messaging.highFiveChannel='new';
		messaging.highFiveChannelFk='new';
		messaging.highFiveReloadUrl=null;
		messaging.highFivesListReloadUrl=null;
		messaging.newHighFiveReloadUrl=null;
		messaging.shoutOutChannel='new';
		messaging.shoutOutChannelFk='new';
		messaging.shoutOutReloadUrl=null;
		messaging.shoutOutsListReloadUrl=null;
		messaging.newShoutOutReloadUrl=null;
		messaging.messageChannel='new';
		messaging.messageChannelFk='new';
		messaging.messageReloadUrl=null;
		messaging.messagesListReloadUrl=null;
		messaging.newMessageReloadUrl=null;
	}
}

